import React from "react";
import "./MacOSWindow.css";

const MacOSWindow = ({ children, activeTab, onTabChange }) => {
  return (
    <div className="macos-window-wrapper">
      <div className="macos-window">
        {/* Title Bar */}
        <div className="macos-titlebar">
          <div className="macos-traffic-lights">
            <div className="traffic-light close"></div>
            <div className="traffic-light minimize"></div>
            <div className="traffic-light maximize"></div>
          </div>

          <div className="macos-title">sbdev.me</div>

          <div className="macos-menu-button">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Tab Bar */}
        <div className="macos-tabbar">
          <button
            className={`macos-tab ${activeTab === "ui" ? "active" : ""}`}
            onClick={() => onTabChange("ui")}
          >
            <span className="tab-label">HR / Visual</span>
          </button>
          <button
            className={`macos-tab ${activeTab === "terminal" ? "active" : ""}`}
            onClick={() => onTabChange("terminal")}
          >
            <span className="tab-label">Dev / Terminal</span>
          </button>
          <button
            className={`macos-tab ${activeTab === "chatbot" ? "active" : ""}`}
            onClick={() => onTabChange("chatbot")}
          >
            <span className="tab-label"> AI Assistant</span>
          </button>
          <a
            href="https://blog.sbdev.me"
            target="_blank"
            rel="noopener noreferrer"
            className="blog-link-badge"
          >
            Blog
          </a>
        </div>

        {/* Content Area */}
        <div className="macos-content">{children}</div>
      </div>
    </div>
  );
};

export default MacOSWindow;
